function picker(err) {
  const msg = typeof err === 'string' ? err : (err.msg || err.message || '网络错误');
  return msg;
}

function show(err) {
  console.log(err);
  const msg = picker(err);
  window.alert(msg);
}

export default {
  picker,
  show,
};
